<template>
  <div>
  <va-modal
    v-model="showTagsListModal"
    :okDisabled="!canClose"
    :noOutsideDismiss="false"
    ref="tagsListModal"
    :cancelText="'users.cancel' | translate"
    :hideDefaultActions="true"
    @cancel="closeTagList">
    <div slot="header">
      <p style="font-size:18px;"><b>{{$t('tags.title')}}</b></p>
    </div>
    <div v-if="isLoading">
      <!-- TODO: -->
      <!-- <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation> -->
    </div>
    <div v-else>
      <tag-form
        v-bind="tagFormProps"
        @newTagAdded="tagWasAdded"
        @newTagUpdated="tagWasUpdated"
        @cancelUpdateTag="cancelUpdateTag">
      </tag-form>
      <div>
        <div class="row">
          <div class="col-sm-6">
            <h5>
              <b>{{$t('tags.tags_available')}}&nbsp;</b>
              <span v-if="filteredTagsList.length > 0">({{filteredTagsList.length}})</span>
            </h5>
          </div>
          <div class="col-sm-6">
            <searchable v-if="tags.length > 0" :querySearch.sync="searchTerm"></searchable>
          </div>
        </div>

        <div class="mb-4 mt-3 ml-2">
          <div v-if="filteredTagsList.length === 0" class="text-center">
            <span><b>{{$t('tags.no_tags_available')}}</b></span>
          </div>
          <div v-else>
            <div class="d-flex justify-content-between">
              <span class="header header__name">{{$t('tags.headers.name')}}</span>
              <span class="header header__color">{{$t('tags.headers.color')}}</span>
              <span class="header header__visibility">{{$t('tags.headers.visibility')}}</span>
              <span class="header header__actions">{{$t('tags.headers.actions')}}</span>
            </div>
            <hr class="header__separator">
            <div v-for="(tag, index) in filteredTagsList" :key="index" class="d-flex justify-content-between tag mw«">
              <span class="tag tag__name">{{tag.name}}</span>
              <span>
                <i class="fa fa-tags" :style="{'color': tag.color}"></i>
              </span>
              <span class="visibility" v-if="tag.visibility === true">
                <i class="fa fa-users" :title="$t('tags.public_tooltip')"></i>
              </span>
              <span class="visibility" v-else>
                <i class="fa fa-user" :title="$t('tags.private_tooltip')"></i>
              </span>
              <div>
                <i class="tag-action-icon fa fa-pencil pl-2" @click.prevent="editTag(tag)"></i>
                <i class="tag-action-icon fa fa-trash pl-2 pr-2" @click.prevent="removeTag(tag)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </va-modal>

  <tag-item-delete
    v-if="isDeletingTag"
    :title="$t('tags.delete_title', {name: selectedTag.name})"
    :body="$t('tags.delete_body', {name: selectedTag.name})"
    @modal-confirmed="deleteConfirmed"
    @modal-canceled="deleteCanceled">
  </tag-item-delete>

  </div>
</template>
<script>
// import LoadingAnimation from '../users/components/Helpers/LoadingAnimation'
// import VuesticAdvancedColorPicker from '../../vuestic-theme/vuestic-components/vuestic-color-picker/VuesticAdvancedColorPicker'
// import VuesticColorSquare from '../../vuestic-theme/vuestic-components/vuestic-color-picker/VuesticColorSquare'
// import VuesticColorPickerInput from '../../vuestic-theme/vuestic-components/vuestic-color-picker/VuesticColorPickerInput'
import TagForm from './TagForm'
import TagItemDelete from '../common/ConfirmationModal'
import Searchable from '../common/Searchable'

export default {
  components: {
    // LoadingAnimation,
    // VuesticAdvancedColorPicker,
    // VuesticColorSquare,
    // VuesticColorPickerInput,
    TagForm,
    TagItemDelete,
    Searchable
  },
  data () {
    return {
      showTagsListModal: false,
      tags: [],
      isLoading: false,
      isDeletingTag: false,
      isEditingTag: false,
      isAddingTag: false,
      selectedTag: null,
      canClose: true,
      styles: {
        width: '15px',
        heigth: '15px',
        'background-color': '#d3d3d3',
        'border-radius': '50%'
      },
      formTag: {
        name: '',
        color: '#ff7b7b'
      },
      errorsBag: {},
      tagFormProps: {},
      searchTerm: '',
      searchableFields: ['name', 'color']
    }
  },
  mounted () {
    this.showTagsListModal = true
    this.loadUserTags()
  },
  computed: {
    filteredTagsList: function () {
      if (this.searchTerm === '') {
        return this.tags
      }
      return this.tags.filter(tagItem => {
        return this.searchableFields.some(field => {
          if (tagItem.hasOwnProperty(field)) {
            return tagItem[field].toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1
          }
        })
      })
    }
  },
  methods: {
    cancelUpdateTag: function () {
      this.selectedTag = null
      this.tagFormProps = {}
    },
    deleteCanceled: function () {
      this.canClose = true
      this.isDeletingTag = false
      this.selectedTag = null
      this.showTagsListModal = true
    },
    deleteConfirmed: function () {
      this.canClose = true
      this.$http({
        url: `${this.$store.state.evollead_server}/tags/${this.selectedTag.id}`,
        method: 'DELETE'
      }).then((response) => {
        this.tags = this.tags.filter(tagItem => tagItem.id !== this.selectedTag.id)
        this.$emit('tagWasDeleted', this.selectedTag)
        this.showToast(this.$t('tags.deleted'), this.$store.state.successToastOptions)
      }).catch((err) => {
        console.log(err)
        this.showToast(this.$t('tags.delete_error'), this.$store.state.errorToastOptions)
      }).finally(() => {
        this.isDeletingTag = false
        this.selectedTag = null
        this.showTagsListModal = true
      })
    },
    getTagColorStyles: function (color) {
      return {
        width: '15px',
        heigth: '15px',
        'background-color': color,
        'border-radius': '50%'
      }
    },
    addTag: function () {
      this.isAddingTag = true
    },
    tagWasAdded: function (tag) {
      this.tags.push(tag)
      this.$emit('tagWasCreated', tag)
      this.showToast(this.$t('tags.created'), this.$store.state.successToastOptions)
    },
    tagWasUpdated: function (tag) {
      let index = this.tags.findIndex(tagItem => tagItem.id === tag.id)
      this.tags[index] = tag
      this.tagFormProps = {}
      this.showToast(this.$t('tags.updated'), this.$store.state.successToastOptions)
      this.$emit('tagWasUpdated', tag)
    },
    removeTag: function (tag) {
      this.canClose = false
      this.$refs.tagsListModal.cancel()
      setTimeout(() => {
        this.selectedTag = tag
        this.isDeletingTag = true
      }, 500)
    },
    cancelEditTag: function () {
      this.isEditingTag = false
      this.isAddingTag = false
      this.selectedTag = null
    },
    editTag: function (tag) {
      this.tagFormProps = {
        isEditingTag: true,
        selectedTag: Object.assign({}, tag)
      }
    },
    closeTagList: function () {
      if (this.canClose) {
        this.$emit('closeTagList')
      }
    },
    baseColorStyles: function () {
      return {
        width: '15px',
        heigth: '15px',
        'border-radius': '50%'
      }
    },
    loadUserTags: function () {
      this.isLoading = true
      this.$http({
        url: `${this.$store.state.evollead_server}/tags`
      }).then((response) => {
        this.tags = response.data.data
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.icons-wrapper{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 20px;
  margin-top: 10px;
}

.fa-times{
  margin-left: 5px;
  cursor: pointer;
  font-size: 1.1em;
}

.fa-check{
  cursor: pointer;
  font-size: 1.1em;
}

.header {
  font-weight: bold;
  margin: 0.2rem;
}

.header__name {
  width: 27%;
}

.tag__name {
  width: 25%;
}

.tag__color {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.tag-action-icon {
  cursor: pointer;
}

.visibility {
  min-width: 50px;
  display: flex;
  justify-content:center;
}

.header {
  font-weight: bold;
}

.header__separator {
  margin: 0.2rem;
}

.tag {
  margin: 0.2rem;
}
</style>
